import { render, staticRenderFns } from "./DataOthersContainer.vue?vue&type=template&id=1f8205c1&scoped=true"
import script from "./DataOthersContainer.vue?vue&type=script&lang=js"
export * from "./DataOthersContainer.vue?vue&type=script&lang=js"
import style0 from "./DataOthersContainer.vue?vue&type=style&index=0&id=1f8205c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8205c1",
  null
  
)

/* custom blocks */
import block0 from "./DataOthersContainer.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports